module.exports = __webpack_public_path__ + "static/media/post-donation.188aa359.svg";